export interface AdminProfile {
  email: string;
  display_name?: string | null;
  role?: 'admin' | 'editor' | 'viewer';
  /** The single publish-approver account; publishes directly + approves others. */
  is_main?: boolean;
}

export interface LoginResponse {
  csrf_token: string;
  admin: AdminProfile;
}

export interface MeResponse {
  admin: AdminProfile;
  csrf_token: string;
}

export type ApiErrorCode =
  | 'unauthorized'
  | 'forbidden'
  | 'csrf_mismatch'
  | 'conflict'
  | 'rate_limited'
  | 'validation'
  | 'not_found'
  | 'server_error'
  | 'network_error'
  | 'unknown';

export class ApiError extends Error {
  status: number;
  code: ApiErrorCode;
  details?: unknown;
  retryAfter?: number;

  constructor(status: number, code: ApiErrorCode, message: string, details?: unknown, retryAfter?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.retryAfter = retryAfter;
  }
}
